<template>
    <v-layout v-if="chairMessage">
        <v-layout pa-2 v-if="chairMessage.message">
            <v-flex xs12 class="chair-message__wrapper">
                <v-card class="chapter-chair-message">

                    <v-flex tag="h2" data-qe-id="chair_msg_title_header"> {{communityCommonConstant.chairMessage.TITLE_HEADER}}
                        <add-chair-message
                            :chair-message="chairMessage"
                            id="ChairMessage_Edit"
                            :class="['chapter-chair-message__edit-button', isEditMode && 'chapter-chair-message__edit-button--on-edit']"
                            @editToggled="toggleEditMode"
                            v-if="chairMessage.canEdit">
                        </add-chair-message>
                    </v-flex>

                  <div v-if="!isEditMode">
                    <v-layout>
                      <v-flex pt-1>
                        <v-list-tile avatar v-for="chair in chapterChairs" :key="chair.lastName">
                          <v-list-tile-avatar xs3>
                            <img data-qe-id="chair_msg_profile_image_chapter_chair" :src="chair.userProfileImageUrl" :onerror="imageErrorFallback(chair.fallbackProfileImageUrl)">
                          </v-list-tile-avatar>
                          <v-list-tile-content xs7>
                            <v-list-tile-title data-qe-id="chair_msg_chapter_chair_name" class="chapter-chair-message__color-light">
                              {{getFullName(chair)}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title data-qe-id="chair_msg_chapter_chair_title" class="chapter-chair-message__text-Position">
                              {{communityChairTitle}}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-flex>
                    </v-layout>
                    <v-card-text
                        v-if="chairMessage.message"
                        class="chapter-chair-message__message-text"
                        data-qe-id="chair_message_text-body"
                        v-html="chapterMessageToDisplay">
                    </v-card-text>
                    <div class="chair-message_more" v-if="showMoreBtn || chairMessageIncludesImage">
                      <v-btn
                          @click="ShowDesc=true"
                          data-qe-id="chair_message_read_more_btn"
                          flat
                          class="primary_btn transparent small">{{communityCommonConstant.SHOW_MORE_BUTTON}}</v-btn>
                    </div>
                  </div>

                </v-card>
            </v-flex>
            <v-dialog
                v-model="ShowDesc"
                width="630"
                align-center>
                <v-card>
                    <v-flex xs12 class="dialog-box__header">
                        <h2 class="dialog-box__font-format" data-qe-id="chair_msg_dialog_header"> {{communityCommonConstant.chairMessage.TITLE_HEADER}} </h2>
                        <div class="imagesection" v-for="chair in chapterChairs" :key="chair.lastName">
                            <v-flex>
                                <v-avatar size="120px">   
                                    <v-img  :src="chair.userProfileImageUrl" :onerror="imageErrorFallback(chair.fallbackProfileImageUrl)" class="dialog-box__img-border" />
                                </v-avatar>
                                <h3>
                                    <span class="dialog-box__color-light" >
                                        {{  getFullName(chair)  }}
                                    </span>
                                </h3>
                                <span class="dialog-box__text-Position" data-qe-id="chair_msg_dialog_chair_title">
                                    {{communityChairTitle}}
                                </span>
                            </v-flex>
                            
                        </div>
                    </v-flex>
                    <div class="dialog-box__content-wrapper">
                      <v-flex
                          xs12
                          max-height="300"
                          v-if="chairMessage.chairMessageImage && chairMessage.chairMessageImage.url && chairMessage.chairMessageImage.url.includes('/chairmessageimage')">
                        <v-img
                            class="dialog-box__img-upload-pos"
                            :src="chairMessage.chairMessageImage.url"
                            max-height="300"
                            max-width="300"
                            align-center>
                        </v-img>
                      </v-flex>
                      <v-card-text
                          data-qe-id="chair_msg_dialog_msg_body"
                          class="dialog-box__message-text "
                          v-html="chairMessage.message">
                      </v-card-text>
                      <v-flex text-xs-right>
                        <v-btn
                            @click="ShowDesc=false"
                            data-qe-id="chair_msg_dialog_close_dialog_btn"
                            class="primary_btn transparent">
                          {{communityCommonConstant.CLOSE_BUTTON}}
                        </v-btn>
                      </v-flex>
                    </div>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout
            class="chair-msg_dialog__new-chair-message"
            v-if="!chairMessage.message && chairMessage.canEdit"
            justify-center>
            <add-chair-message
                :chair-message="chairMessage"
                :community-chair-title="communityChairTitle"
                editor-id="newChairMessage"></add-chair-message>
        </v-layout>
    </v-layout>
</template>

<script>
    import { mapGetters } from "vuex";
    import { communityCommonConstant } from "../communityCommon.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import AddChairMessage from "./AddChairMessage";
    import CkEditor from "../../CkEditor/CkEditor";
    import sortBy from "lodash/sortBy";
    import { capitalizedString, imageErrorFallback } from "../../../common/utils/utils";

    export default {
        name: "ChairMessage",
        components: {
            CkEditor,
            AddChairMessage,
        },
        data: () => {
            return {
                communityCommonConstant,
                ShowDesc: false,
                isEditMode: false,
            };
        },
      methods: {
            getFullName(chapterChair) {
                return `${chapterChair.firstName} ${chapterChair.lastName}`;
            },
            imageErrorFallback,
            toggleEditMode(val) {
              this.isEditMode = val;
            },
        },
        computed: {
            ...mapGetters({
                chairMessage: `chapter/${storeGetters.chairMessage}`,
            }),
            communityChairTitle() {
                return `${capitalizedString(this.$store.getters[storeGetters.communityName])} ${communityCommonConstant.chairMessage.CHAIR}`;
            },
            chapterMessageToDisplay() {
                const dots = "...";
                return this.chairMessage.message.length >
                    communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH ?
                    this.chairMessage.message.substring(
                        0,
                        communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH,
                    ) + dots :
                    this.chairMessage.message;
            },
            chapterChairs() {
                return sortBy(this.chairMessage.chapterChairs, 'lastName').slice(0, 2);
            },
            showMoreBtn() {
                return this.chairMessage && this.chairMessage.message && (
                    this.chairMessage.message.length >
                    communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH
                );
            },
          chairMessageIncludesImage() {
              return (this.chairMessage && this.chairMessage.chairMessageImage && this.chairMessage.chairMessageImage.url.includes('/chairmessageimage'));
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .chapter-chair-message {
        border-radius: 4px;
        box-shadow: none;
        padding: 0;
        margin: 0;

        &__color-light {
            color: $ypo_blue;
            font-size: 16px;
        }

        &__message-text {
            font-size: 12px;
            line-height: 20px;
            color: $ypo_blue;
            padding: 10px 15px 5px 15px;
            word-wrap: break-word;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        &__text-Position {
            font-weight: 600;
            color: $ypo-gray-text;
            font-size: 12px;
        }

        &__btn-show-more {
            font-weight: bold;
            color: $ypo-duskblue;
        }

        &__edit-button {
            position: absolute;
            top: 0;
            right: 0px;

          &--on-edit {
            position: relative;
          }
        }
    }

    .dialog-box {
        &__header {
            background-color: $ypo-dark-background-gray;
            text-align: center;
            height: 160px;
            position: relative;

            .imagesection {
                display: inline-flex;
                justify-content: space-around;
                 width:50%;
                 margin-top: 20px;
            }
            
            .v-avatar {
                bottom: 0;
                img {
                    border: 7px solid $ypo-dark-background-gray;
                }
                .v-image {
                    border: 7px solid $ypo-dark-background-gray;
                }
            }
        }

        &__img-upload-pos {
            margin-left: auto;
            margin-right: auto;
        }

        &__edit-btn-postion {
            margin-right: 0px;
            float: right;
            color: $ypo-cta;
        }

        &__color-light {
            font-weight: 500;
            color: $ypo-duskblue;
        }

      &__content-wrapper {
        margin-top: 140px;
      }

        &__message-text {
            color: $ypo_blue;
            word-wrap: break-word;
            border-bottom: 1px solid $ypo-about-border;
            padding: 10px 30px;
            margin-top: 30px;
            font-size: 14px;
            line-height: 24px;
        }

        &__text-Position {
            font-size: 12px;
            font-weight: 600;
        }

        &__btn-align {
            color: $ypo-cta;
            font-weight: bold;
        }

        &__padding-space {
            padding-bottom: 0px;
        }

        &__font-format {
            font-weight: 400;
            color: $white;
            padding-top: 45px;
            letter-spacing: 0.25px;
        }

        &__chapter-name {
            margin-top: 33px;
            text-align: center;
        }

        &__message-desc-border {
            border-bottom: 1px solid $ypo-text-border;
            margin-top: 25px;
        }

        &__padding-text-left {
            text-align: center;
            margin-top: 15px;
            margin-right: auto;
            margin-left: auto;
        }
    }

    .chair-message__wrapper {
        border: 1px solid $ypo-medium-gray;
        border-radius: 4px;

        &__new-chair-message {
            text-align: center;
            padding: 10px 20px;
        }
    }

    .chair-message_more {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }
</style>
